<template>
  <div id="deposit_voucher" v-if="regulatorIncluded">
    <el-form-item name="redemptionCode">
      <el-select
        class="deposit_voucher_selector"
        :value="null"
        @change="selectVoucherChange"
        data-testid="formVoucher"
        :popper-append-to-body="false"
        placeholder=""
        :disabled="disableDropdown || isDisable"
      >
        <template slot="prefix">
          <div class="voucher_prefix" v-if="redemptionCode">
            <div class="voucher_icon">
              <img src="@/assets/images/payment/common/voucher.png" alt="voucher" />
            </div>
            <div>
              <span class="voucher-selected-name">
                {{ $t('depositDiscount.description', { amount: voucherInfo.amount }) }}</span
              ><br />
            </div>
          </div>
          <div v-else class="voucher_prefix">
            <div class="voucher_icon">
              <img src="@/assets/images/payment/common/voucher.png" alt="voucher" />
            </div>
            <div>{{ $t('loyaltyProgram.depositDiscount.voucherSelectTooltip') }}</div>
          </div>
        </template>
        <el-option
          v-for="(item, index) in showVoucherList"
          class="voucher_dropdown"
          :key="index"
          :value="item.id"
          :data-testid="item.id"
        >
          <div>
            <span class="voucher_name"> {{ $t('depositDiscount.description', { amount: item.amount }) }} </span><br />
            <span v-if="item.expireTime" class="voucher_date">
              {{ voucherExpireText(item.expireTime) }}
            </span>
            <span v-if="item.expireTime" class="voucher_date voucher_ref">
              {{ $t('loyalty.myVouchers.voucherId') }}:&nbsp;{{ item.id }}
            </span>
          </div>
        </el-option>
        <template slot="empty">
          <div class="custom-empty">
            <img src="@/assets/images/payment/common/record_not_found.png" alt="no record found" />
            <!-- <img src="@/assets/images/payment/common/noData.png" alt="no data" /> -->
            <div class="d-flex">
              <p>{{ $t('deposit.default.noVoucher') }}</p>
              <!-- <router-link :to="{ name: 'clubBleu' }" data-testid="clubBleu">
                <span class="text_link"
                  >{{ $t('deposit.default.checkPointsCenter') }} <span class="suffix">></span>
                </span>
              </router-link> -->
            </div>
          </div>
        </template>
      </el-select>
      <!-- <div class="hint">*{{ $t('loyaltyProgram.depositDiscount.voucherNote') }}</div> -->
    </el-form-item>
  </div>
</template>
<script>
import { SVG } from '@/constants/regulator';
import { apiGetDepositDiscountVoucher, apiQueryRate_USD_JPY } from '@/resource';
import uscMixin from '@/mixins/usc';
import rounding from '@/util/rounding';
import moment from 'moment';

export default {
  name: 'DepositVoucher',
  props: {
    depositAmount: {
      type: Number,
      default: 0
    },
    currency: {
      type: String,
      default: 'USD'
    },
    depositAccount: { type: [Number, String], default: null },
    isDisable: { type: Boolean, default: false }
  },
  mixins: [uscMixin],
  data() {
    return {
      chosenVoucher: null,
      initialVoucherList: [],
      voucherList: [],
      showVoucherList: [],
      redemptionCode: null,
      discRateChange: 0
    };
  },
  computed: {
    regulatorIncluded() {
      return this.regulator === SVG;
    },
    voucherInfo() {
      return this.voucherList.find(item => item.id === this.redemptionCode);
    },
    disableDropdown() {
      return this.enteredAmount <= 0 || this.voucherList.length <= 0;
    }
  },
  watch: {
    depositAccount() {
      this.getShowedVoucherList();
    },
    depositAmount() {
      this.updateVoucherList();
    }
  },
  methods: {
    async getAvailableVouchers() {
      apiGetDepositDiscountVoucher()
        .then(resp => {
          if (resp.data.code === 0) {
            this.voucherList = this.mapDepositDiscountList(resp.data.data);
          }
        })
        .catch(err => {
          this.errorMessage(this.$t('responseMsg.500'));
        });
    },
    mapDepositDiscountList(depositDiscountList) {
      if (depositDiscountList.length > 0) {
        return depositDiscountList.map(item => ({
          id: item.code,
          amount: item.amount,
          capAmount: item.capAmount,
          // rebate: item.rebate,
          rewardId: item.rewardId,
          rewardName: item.rewardName,
          expireTime: item.expireTime,
          deposit: item.deposit
          // userCouponId: item.userCouponId
        }));
      } else {
        return [];
      }
    },
    async getShowedVoucherList() {
      await this.getAvailableVouchers();
      if (this.currency === 'JPY') {
        await this.queryDisRate_USD_JPY();
      }

      this.showVoucherList = this.voucherList.filter(voucher => {
        return this.rateConversion(voucher.deposit) <= this.depositAmount;
      });
    },
    updateVoucherList() {
      this.showVoucherList = this.voucherList.filter(voucher => {
        return this.rateConversion(voucher.deposit) <= this.depositAmount;
      });
    },
    selectVoucherChange(value) {
      this.redemptionCode = value;
      const selectedVoucher = this.voucherList.find(item => item.id === value);

      this.$emit('selectVoucherChange', {
        redemptionCode: value,
        voucherApplied: this.$t('depositDiscount.description', { amount: selectedVoucher.amount }),
        // userCouponId: selectedVoucher.userCouponId,
        capAmount: selectedVoucher.capAmount,
        couponType: selectedVoucher.rewardName
      });
    },
    goPointsCenter() {
      this.$router.push('/clubBleu');
    },
    voucherExpireText(date) {
      let newDate = `${moment(date).format('DD')} ${this.$t(
        `common.month.${moment(date).format('MMM').toLowerCase()}`
      )} ${moment(date).format('YYYY')}`;
      let renderText = this.isExpiredSoon(date)
        ? this.$t('loyalty.redeemVoucher.expiresIn', {
            duration:
              moment.utc(date).diff(moment(), 'hours') > 0
                ? `${this.$t('common.hour', { hour: moment.utc(date).diff(moment(), 'hours') })}`
                : `${this.$t('common.minute', { minutes: moment.utc(date).diff(moment(), 'minutes') })}`
          })
        : this.$t('loyalty.redeemVoucher.validTill', {
            date: newDate
          });
      return renderText;
    },
    isExpiredSoon(date) {
      let isExpireSoon = moment.utc(date).diff(moment(), 'days') < 1;
      return isExpireSoon;
    },
    rateConversion(amount, round = true) {
      switch (this.currency) {
        case 'JPY':
          return round ? rounding(Math.ceil, amount * this.discRateChange, 0) : amount * this.discRateChange;
        case 'USC':
          return (amount * 1000000) / 10000;
        default:
          return amount;
      }
    },
    async queryDisRate_USD_JPY() {
      apiQueryRate_USD_JPY()
        .then(resp => {
          if (resp.data.code == 0) {
            this.discRateChange = resp.data.data;
          }
        })
        .catch(err => {
          this.errorMessage(
            this.$t('deposit.default.rate.result.rateError', {
              oldCurrency: 'USD',
              newCurrency: 'JPY'
            })
          );
        });
    }
  },
  async created() {
    this.getShowedVoucherList();
  }
};
</script>

<style lang="scss" scoped>
div[data-testid='formVoucher'] {
  /deep/ .el-select-dropdown.el-popper {
    left: 0px !important;
  }
}

#deposit_voucher {
  .el-select:hover {
    /deep/ .el-input__inner {
      border: 1px solid #1e1e1e73;
      transition: background-color 0.3s ease;
    }
  }
  /deep/ .el-input__inner {
    font-size: 14px;
    height: 48px;
    background-color: #3d3d3d0a;
    border-radius: 10px;
    border: 0;
  }
  /deep/ .el-input__prefix {
    @include rtl-sass-prop(left, right, 5px);
  }
  .voucher_prefix {
    display: flex;
    align-items: center;
    height: 100%;
    line-height: 1;
    text-align: start;
    @include rtl-sass-prop(padding-left, padding-right, 10px);

    > .voucher_icon {
      width: 18px;
      @include rtl-sass-prop(margin-right, margin-left, 8px);
    }

    .voucher-selected-name {
      color: $black;
    }
  }
  .custom-empty {
    padding: 40px 20px;
    text-align: center;
    img {
      width: 60px;
    }
    .d-flex {
      text-align: center;
      font-size: 12px;
      justify-content: center;
      align-items: center;
      > p {
        color: rgba($PCS-main-text, 0.45);
      }
      .text_link,
      .suffix {
        color: $red-orange;
      }
      .text_link {
        @include rtl-sass-prop(padding-left, padding-right, 2px);
      }
    }
  }
  .hint {
    color: $PCS-main-text;
    line-height: 19px;
    margin-top: 20px;
  }
  .voucher_dropdown {
    height: auto;
    min-height: 40.5px;
    line-height: 1.5rem;
    /* padding: 10px; */
    padding: 10px 20px;
  }
  .voucher_date {
    font-size: 12px;
    font-weight: normal;
    color: #404040;
  }
  .voucher_ref {
    float: right;
  }
}
</style>
